// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2W1Tj","errorLogs":"styles_errorLogs__2xmwP"};